<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="直播编号：">
            <el-input v-model="query.liveId" placeholder="请输入直播编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播主题：">
            <el-input v-model="query.liveTitle" placeholder="请输入直播主题" clearable size="small" />
          </el-form-item>
          <el-form-item label="主播手机号：">
            <el-input v-model="query.liveAnchorMobile" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <!-- <el-form-item label="主播职位：">
            <el-select v-model="query.streamerIdentity" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="技术老师" :value="1"></el-option>
              <el-option label="督导" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="抽奖分配：">
            <el-select v-model="query.lotteryDistribution" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="随机" :value="1"></el-option> -->
              <!-- <el-option label="每个相同" :value="2"></el-option> -->
              <!-- <el-option label="指定人中奖" :value="3"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <!-- 导出按钮 -->
      <!-- <div class="export-container mb10">
        <div class="export-btn">
          <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button>
        </div>
      </div> -->
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="直播间" prop="liveId" align="center" />
        <el-table-column label="主播信息" prop="streamerName" align="center">
          <template slot-scope="{row}">
            {{ row.userRealNameAnchor +"-"}}{{ row.userMobileAnchor+"-" }}{{ row.userLevelNameAnchor }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="福袋类型" align="center">
          <template slot-scope="{row}">
            <span v-if="row.type === 1">商品福袋</span>
            <span v-else-if="row.type === 2">零售价福袋</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="getType" label="抽奖分配" align="center">
          <template slot-scope="{row}">
            <span v-if="row.getType === 1">随机</span>
            <span v-else-if="row.getType === 2">指定人中奖</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalUserCount" label="是否重复中奖" align="center">
          <template slot-scope="{row}">
            <span v-if="row.isCanRepeatWinning&&row.getType === 1">是</span>
            <span v-else-if="!row.isCanRepeatWinning&&row.getType === 1">否</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="levelIdsWinning" label="抽奖权限" align="center">
          <template slot-scope="{row}">
            <span v-if="row.levelIdsWinning">{{ formatLevelIdsWinning(row.levelIdsWinning) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品" align="center">
          <template slot-scope="{row}">
            <span v-if="row.type === 1 && row.items && row.items.length > 0 && row.items[0].goodsInfo && row.items[0].goodsInfo.name">
              {{ row.items[0].goodsInfo.name }}
            </span>
            <span v-else-if="row.type === 1 && row.items && row.items.length > 0 && row.items[0].goodsInfo && (row.items[0].goodsInfo.spec || '无规格值')">
              {{ row.items[0].goodsInfo.spec || '无规格值' }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalUserCount" label="中奖名额" align="center">
          <template slot-scope="{row}">
            <span v-if="row.getType === 1">{{ row.totalUserCount == null ? '-' : row.totalUserCount }}</span>
            <span v-else-if="row.getType === 2 && Array.isArray(row.items)">{{ row.items.length }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalXdbAmount" label="零售价中奖总额" align="center" />
        <el-table-column prop="totalXdbAmount" label="奖品明细" align="center">
          <template slot-scope="{row}">
            <el-link type="primary" v-if=" row.items && row.items.length > 0" @click="handleViewAmountDetail(row)">查看详情</el-link>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" align="center">
          <template slot-scope="{row}">
            <span>{{ row.createdTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lookTime" label="抽奖门槛" align="center">
          <template slot-scope="{row}">
            <span v-if="row.lookTime">{{ row.lookTime>0?row.lookTime+'分钟':'不设置' }}</span>
            <span v-else>不设置</span>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="抽奖时间" align="center">
          <template slot-scope="{row}">
            <span v-if="row.startTime">{{ row.startTime }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="drawFewMinuteStart" label="开奖时间" align="center">
          <template slot-scope="{row}">
            <span v-if="row.drawFewMinuteStart && row.startTime">{{row.drawFewMinuteStart}}分钟{{ dayjs(row.startTime).add(row.drawFewMinuteStart, 'minute').format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="blessings" label="开奖口令" align="center" />
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.status === 10" type="info">未开始</el-tag>
            <el-tag v-else-if="row.status === 20" type="warning">抽奖中</el-tag>
            <el-tag v-else-if="row.status === 30" type="success">已抽奖</el-tag>
            <el-tag v-else-if="row.status === 40" type="danger">已取消</el-tag>
            <el-tag v-else type="info">-</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="downTime" label="结束时间" align="center">
          <template slot-scope="{row}">
            <span v-if="row.startTime && row.drawFewMinuteStart">{{ dayjs(row.startTime).add(row.drawFewMinuteStart, 'minute').format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">抽奖明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <show-vue ref="showVue"  />
    <bag-vue ref="bagVue"  />
    
    <!-- 抽奖明细弹窗 -->
    <el-dialog :visible.sync="recordVisible" width="1200px" title="抽奖明细" append-to-body :close-on-click-modal="false">
      <div class="filter-container">
        <el-form :model="recordQuery" ref="recordQueryForm" :inline="true">
          <el-form-item label="抽奖人信息：">
            <el-input
              v-model="recordQuery.keywords"
              placeholder="请输入姓名/手机号"
              clearable
              size="small"
              style="width: 200px;"
            />
          </el-form-item>
          <el-form-item label="中奖状态：">
            <el-select
              v-model="recordQuery.status"
              placeholder="全部"
              clearable
              size="small"
              style="width: 150px;"
            >
              <el-option label="已报名" :value="0"></el-option>
              <el-option label="中奖" :value="1"></el-option>
              <el-option label="未中奖" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleRecordQuery" size="mini">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 统计信息 -->
      <div class="statistics-info" style="color: #f56c6c; margin: 10px 0;">
        参与人数: {{ recordTotal || 0 }}、中奖人数: {{ statisticsInfo.winCount || 0 }}
      </div>
      <el-table :data="recordList" v-loading="recordLoading" style="width: 100%; margin-top: 20px;">
        <el-table-column label="抽奖人信息" align="center">
          <template slot-scope="{row}">
            <span>{{ formatUserInfo(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="参与时间" align="center">
          <template slot-scope="{row}">
            <span>{{ row.createdTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="中奖状态" align="center">
          <template slot-scope="{row}">
            <span v-if="row.state === 0">已报名</span>
            <span style="color: #f56c6c;" v-else-if="row.state === 1">中奖</span>
            <span v-else-if="row.state === 2">未中奖</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="中奖明细" align="center">
          <template slot-scope="{row}">
            <span v-if="row.state === 1">
              <span v-if="row.winning && row.winning.xdbAmount">{{ row.winning.xdbAmount }}零售价</span>
              <span v-else-if="row.winning && row.winning.goodsInfo">
                <span v-if="row.winning.goodsInfo.name">{{ row.winning.goodsInfo.name }}</span>
                <span v-if="(row.winning.goodsInfo.spec || '无规格值') && (row.winning.goodsInfo.spec || '无规格值') !== row.winning.goodsInfo.name">
                  {{ row.winning.goodsInfo.name ? '+' : '' }}{{ row.winning.goodsInfo.spec || '无规格值' }}
                </span>
              </span>
              <span v-else>-</span>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination 
        v-show="recordTotal > 0" 
        :total="recordTotal" 
        :page.sync="recordQuery.pageNo" 
        :limit.sync="recordQuery.pageSize" 
        @pagination="doQueryRecordList" 
      />
    </el-dialog>
    
    <!-- 中奖金额详情弹窗 -->
    <el-dialog :visible.sync="amountDetailVisible" width="800px" title="奖品明细" append-to-body :close-on-click-modal="false">
      <el-table :data="amountDetailList" v-loading="amountDetailLoading" style="width: 100%;">
        <el-table-column prop="designatedUserId" label="指定人用户id" align="center" v-if="currentDetailGetType === 2">
          <template slot-scope="{row}">
            <span>{{ row.designatedUserId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" align="center" v-if="currentDetailType === 1">
          <template slot-scope="{row}">
            <span>{{ row.goodsName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="xdbAmount" label="中奖零售价" align="center" v-if="currentDetailType === 2">
          <template slot-scope="{row}">
            <span>{{ row.xdbAmount || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalCount" label="中奖名额" align="center">
          <template slot-scope="{row}">
            <span>{{ row.totalCount || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import liveBlessingBagApi from '@/api/live/liveBlessingBag'
import liveBlessingBagSignUpApi from '@/api/live/liveBlessingBagSignUp'
import Pagination from '@/components/Pagination'
import showVue from './show'
import bagVue from './bag'
export default {
  components: {
    Pagination,
    showVue,
    bagVue
  },
  data() {
    return {
      list: [],
      identityNames: {},
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      // 抽奖记录相关
      recordVisible: false,
      recordList: [],
      recordTotal: 0,
      recordLoading: false,
      recordQuery: {
        blessingBagId: null,
        keywords: '',
        status: null,
        pageNo: 1,
        pageSize: 10
      },
      currentBagId: null,
      statisticsInfo: {
        totalCount: 0,
        winCount: 0
      },
      // 中奖金额详情相关
      amountDetailVisible: false,
      amountDetailList: [],
      amountDetailLoading: false,
      currentDetailType: null, // 当前查看详情的福袋类型
      currentDetailGetType: null // 当前查看详情的抽奖分配类型
    }
  },
  created() {
    this.loadIdentityNames()
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    getStatusType(status) {
      const statusMap = {
        10: 'info',    // 未开始
        20: 'warning', // 抽奖中
        30: 'success', // 已抽奖
        40: 'danger'   // 已取消
      }
      return statusMap[status] || 'info'
    },
    /**
     * 获取状态文本
     */
    getStatusText(status) {
      const statusMap = {
        10: '未开始',
        20: '抽奖中',
        30: '已抽奖',
        40: '已取消'
      }
      return statusMap[status] || '未知'
    },
    /**
     * 打开抽奖记录弹窗
     */
    handleShow(row) {
      if (!row.id) {
        this.$message.error('缺少福袋ID')
        return
      }
      this.currentBagId = row.id
      this.recordQuery.blessingBagId = row.id
      this.recordQuery.pageNo = 1
      this.recordQuery.pageSize = 10
      this.recordQuery.keywords = ''
      this.recordQuery.status = null
      // 重置统计信息，避免显示旧数据
      this.statisticsInfo = {
        totalCount: 0,
        winCount: 0
      }
      this.recordVisible = true
      this.doQueryRecordList({ pageNo: 1, pageSize: 10 })
      this.getStatisticsCount()
    },
    handleBag(row) {
      this.$refs.bagVue.handleShow(row)
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
      }
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createTime': 'createTimeSortSign',
        'lotteryTime': 'lotteryTimeSortSign',
        'drawTime': 'drawTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      
      // 构建查询参数，清理空值并转换类型
      const params = { ...this.query }
      
      // 处理 liveId：如果是字符串且不为空，转换为数字
      if (params.liveId) {
        const liveIdNum = parseInt(params.liveId)
        if (!isNaN(liveIdNum)) {
          params.liveId = liveIdNum
        } else {
          delete params.liveId
        }
      } else {
        delete params.liveId
      }
      
      // 清理其他空值参数
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })
      
      return liveBlessingBagApi.fetchList(params)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 导出数据
     */
    handleExport() {
      // 实现导出功能
    },
    /**
     * 计算开奖时间：startTime + lookTime分钟
     */
    getOpenTime(row) {
      if (!row.startTime) return ''
      if (!row.lookTime) {
        return this.dayjs(row.startTime).format('YYYY-MM-DD HH:mm:ss')
      }
      // startTime + lookTime分钟
      const openTime = this.dayjs(row.startTime).add(row.lookTime, 'minute')
      return openTime.format('YYYY-MM-DD HH:mm:ss')
    },
    /**
     * 查看中奖金额详情
     */
    handleViewAmountDetail(row) {
      if (!row || !row.items || row.items.length === 0) {
        this.$message.warning('暂无奖品明细')
        return
      }
      
      this.currentDetailType = row.type
      this.currentDetailGetType = row.getType
      
      // 根据福袋类型处理数据
      if (row.type === 2) {
        // 零售价福袋
        if (row.getType === 2) {
          // 指定人中奖：显示每个用户的详细信息，不分组
          this.amountDetailList = row.items.map(item => ({
            designatedUserId: item.designatedUserId || '-',
            xdbAmount: item.xdbAmount || 0,
            totalCount: item.totalCount || 0
          }))
        } else {
          // 随机中奖：按金额分组统计
          const amountMap = {}
          row.items.forEach(item => {
            const amount = item.xdbAmount || 0
            if (amountMap[amount]) {
              amountMap[amount].totalCount += item.totalCount || 0
            } else {
              amountMap[amount] = {
                xdbAmount: amount,
                totalCount: item.totalCount || 0
              }
            }
          })
          this.amountDetailList = Object.values(amountMap)
        }
      } else if (row.type === 1) {
        // 商品福袋：显示商品信息
        this.amountDetailList = row.items.map(item => ({
          designatedUserId: item.designatedUserId || '-',
          totalCount: item.totalCount || 0,
          goodsName: item.goodsInfo ? (item.goodsInfo.name || item.goodsInfo.spec || '无规格值') : '-'
        }))
      } 
      
      this.amountDetailVisible = true
    },
    // 与创建表单及直播内福袋列表使用同一份客户身份字典。
    loadIdentityNames() {
      const names = Object.create(null)
      try {
        const levels = JSON.parse(localStorage.getItem('levelList')) || []
        if (Array.isArray(levels)) {
          levels.forEach(level => {
            if (level && level.id != null && typeof level.name === 'string' && level.name.trim()) {
              names[String(level.id)] = level.name
            }
          })
        }
      } catch (_) {
        // 字典不可用时保留原ID，不猜测身份名称。
      }
      this.identityNames = names
    },
    /** 格式化抽奖权限显示，未知身份保留原ID。 */
    formatLevelIdsWinning(levelIdsWinning) {
      if (!levelIdsWinning) return '-'
      
      // 将字符串按逗号分割，转换为数组，然后映射为中文名称
      const ids = String(levelIdsWinning).split(',').map(id => id.trim())
      const names = ids.map(id => this.identityNames[id] || id).filter(name => name)
      
      return names.length > 0 ? names.join('、') : levelIdsWinning
    },
    /**
     * 查询抽奖记录列表
     */
    doQueryRecordList({ pageNo, pageSize }) {
      if (pageNo) {
        this.recordQuery.pageNo = pageNo
      }
      if (pageSize) {
        this.recordQuery.pageSize = pageSize
      }
      this.recordLoading = true
      const params = {
        blessingBagId: this.recordQuery.blessingBagId,
        pageNo: this.recordQuery.pageNo,
        pageSize: this.recordQuery.pageSize
      }
      // 如果有搜索关键字，添加 keywords 参数
      if (this.recordQuery.keywords) {
        params.keywords = this.recordQuery.keywords
        params.userType = 20
      }
      // 如果有中奖状态，添加 status 参数
      if (this.recordQuery.status !== null && this.recordQuery.status !== undefined && this.recordQuery.status !== '') {
        params.status = this.recordQuery.status
      }
      // 如果有用户类型，添加 userType 参数
      if (this.recordQuery.userType !== null && this.recordQuery.userType !== undefined && this.recordQuery.userType !== '') {
        params.userType = this.recordQuery.userType
      }
      
      return liveBlessingBagSignUpApi.fetchList(params)
        .then(data => {
          this.recordList = data.data.list || []
          this.recordTotal = data.data.total || 0
        })
        .catch(err => {
          console.error('获取抽奖记录失败:', err)
          this.$message.error(err.message || '获取抽奖记录失败')
          this.recordList = []
          this.recordTotal = 0
        })
        .finally(() => {
          this.recordLoading = false
        })
    },
    /**
     * 搜索抽奖记录
     */
    handleRecordQuery() {
      this.doQueryRecordList({ pageNo: 1 })
      this.getStatisticsCount()
    },
    /**
     * 获取统计人数
     */
    getStatisticsCount() {
      if (!this.recordQuery.blessingBagId) {
        return
      }
      const params = {
        blessingBagId: this.recordQuery.blessingBagId
      }
      params.status = 1
      
      liveBlessingBagSignUpApi.getCount(params)
        .then(data => {
          if (data && data.data !== undefined && data.data !== null) {
            this.statisticsInfo = {
              totalCount: 0,
              winCount: data.data || 0
            }
          } else {
            // 如果接口返回的数据格式不正确，重置为0
            this.statisticsInfo = {
              totalCount: 0,
              winCount: 0
            }
          }
        })
        .catch(err => {
          console.error('获取统计人数失败:', err)
          // 失败时重置为0，不显示错误提示，避免影响用户体验
          this.statisticsInfo = {
            totalCount: 0,
            winCount: 0
          }
        })
    },
    /**
     * 格式化用户信息显示
     */
    formatUserInfo(row) {
      if (!row) return '-'
      const name = row.userRealName || ''
      const phone = row.userMobile || ''
      const position = row.userLevelName || ''
      
      if (!name && !phone) return '-'
      
      let result = name || phone
      if (phone && name) {
        result = `${name}（${phone}${position ? '-' + position : ''}）`
      } else if (phone) {
        result = phone
      }
      
      return result
    }
  }
}
</script>

<style scoped>
.export-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.export-btn {
  margin-left: auto;
}

.item-count {
  color: #409EFF;
  font-weight: 500;
}

.mb10 {
  margin-bottom: 10px;
}

.mt10 {
  margin-top: 10px;
}
</style>
